import React, { Component } from 'react';
import { Button, Form, Row, Col, Input, Table, Select } from 'antd';
import { toJS } from 'mobx';
import { CopyOutlined, UnlockOutlined, EditOutlined, LockOutlined, SearchOutlined, PlusOutlined } from '@ant-design/icons';
import dataTargetAPI from '../../apis/dataTarget'
import { getPaginationConfig } from '../../components/pagination';
import AddModal from './components/AddModal'
import FormImport from './components/FormImport'
import CopyModal from './components/CopyModal'
import EditModal from './components/EditModal'
import UPM from '../../constants/urlPermissionMappings';
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

class dataTarget extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    copyModalVisible: false,
    addModalVisible: false,
    importModalVisible: false,
    editModalVisible: false,
    id: null,
    tableData: [],
    exportDB: [],
    boundVisible: false
  }
  formRef = React.createRef();

  componentDidMount() {
    this.handleSearch()
  }

  handleSearch = (page, size) => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        targetName: fieldsValue.targetName,
        targetType: fieldsValue.targetType,
        status: fieldsValue.status,
        page: page ? page : this.state.page,
        size: size ? size : this.state.size,
      }
      dataTargetAPI.searchAction(params).then(res => {
        this.setState({
          tableData: res.data.data?.records,
          page: res.data.data.current, // 当前页
          size: res.data.data.size, // 每页显示条数
          total: res.data.data.total // 总条数
        })
      })
    }).catch(err => {

    })
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = (target) => {
    this.setState({
      [target]: false
    })
  }

  handlePageChange = (page, pageSize) => {
    // page 目标页
    // pageSize 显示条数
    this.handleSearch(page, pageSize)
  }

  handleImport = () => {
    this.setState({
      importModalVisible: true
    })
  }

  handleExport = () => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        targetName: fieldsValue.targetName,
        targetType: fieldsValue.targetType,
        status: fieldsValue.status,
      }
      dataTargetAPI.exportAction(params).then(res => {
        var blob = new Blob([res.data.data], { type: "text/plain;charset=utf-8" }); //解决中文乱码问题
        blob = new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
        //设置链接
        var link = window.URL.createObjectURL(blob);
        var a = document.createElement("a"); //创建a标签
        a.download = "DataTargetConfig.txt"; //设置被下载的超链接目标（文件名）
        a.href = link; //设置a标签的链接
        document.body.appendChild(a); //a标签添加到页面
        a.click(); //设置a标签触发单击事件
        document.body.removeChild(a); //移除a标签
      })
    }).catch(err => {

    })
  }

  handleCopy = (id) => {
    this.setState({
      copyModalVisible: true,
      id
    })
  }

  handleEdit = (id) => {
    this.setState({
      editModalVisible: true,
      id
    })
  }

  handleLock = (record) => {
    let params = {
      id: record.id,
      status: record.statusAlias === 'Active' ? 'Inactive' : 'Active'
    }
    dataTargetAPI.lockAction(params).then(res => {
      this.handleSearch()
    })
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const { location,t } = this.props
    const pagination = getPaginationConfig(this.state.page, this.state.size, this.state.total, this.handlePageChange);

    return (
      <div className="container">
        <Form ref={this.formRef} size='middle' className='searchForm' layout="vertical">
          <div className='searchFormTitle'>
            <SearchOutlined /> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10,0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name='targetName' label={t(`dataTarget.targetName`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name='targetType' label={t(`dataTarget.targetType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChange} allowClear>
                  <Select.Option key='HTTP' value='HTTP'>HTTP</Select.Option>
                   <Select.Option key='DB' value='DB'>DB</Select.Option>
                  <Select.Option key='SFTP' value='SFTP'>SFTP</Select.Option>
                  <Select.Option key='Blob' value='Blob'>Blob</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name='status' label={t(`dataTarget.status`)}>
                <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChange} allowClear>
                  <Select.Option key='Active' value='Active'>Active</Select.Option>
                  <Select.Option key='Inactive' value='Inactive'>Inactive</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} style={{ textAlign: 'right', marginTop: 30 }}>
              <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type='primary' icon={<PlusOutlined />}>{t(`general.add`)}</Button>
              {/* <Button onClick={this.handleImport} type='primary' icon={<UploadOutlined />}>Import</Button>
              <Button onClick={this.handleExport} type='primary' icon={<DownloadOutlined />}>Export</Button> */}
            </Col>
          </Row>
        </Form>

        <Table className='searchResult' dataSource={toJS(this.state.tableData)} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>
          <Table.Column width={80} align='center' title={t(`dataTarget.status`)} dataIndex="statusAlias" key="statusAlias" ellipsis={true}
            render={(text) => <div style={{ display: 'inline-block', height:24, width: 24, lineHeight: '24px', fontSize: 12, borderRadius: 24, color: 'white', textAlign: 'center', 
              background: text === 'Active' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'Inactive' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : 'none'}} 
            title={text}>{text.charAt(0)}</div>}
          />
          <Table.Column title={t(`dataTarget.targetName`)} dataIndex="targetName" key="targetName" ellipsis={true} />
          <Table.Column title={t(`dataTarget.targetType`)} dataIndex="targetType" key="targetType" ellipsis={true} />
          <Table.Column title={t(`dataTarget.creator`)} dataIndex="createUser" key="createUser" ellipsis={true} />
          <Table.Column title={t(`dataTarget.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true} />
          <Table.Column width={200} align='center' title={t(`general.action`)} key="Action" render={(record, index) => {
            return (
              <>
                <Button type='link' onClick={() => this.handleCopy(record.id)} icon={<CopyOutlined />} title={t(`general.copy`)} />
                <Button type='link' onClick={() => this.handleEdit(record.id)} icon={<EditOutlined />} title={t(`general.edit`)} />
                {
                  record.statusAlias === 'Active' ? (
                    <Button type='link' onClick={() => this.handleLock(record)} icon={<UnlockOutlined />} title={t(`general.active`)} />
                  ) : (
                    <Button type='link' className='grey' onClick={() => this.handleLock(record)} icon={<LockOutlined />} title={t(`general.inactive`)} />
                  )
                }
              </>
            )
          }} />
        </Table>
        {this.state.addModalVisible ? <AddModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} addModalVisible={this.state.addModalVisible} /> : null}
        {this.state.editModalVisible ? <EditModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} id={this.state.id} editModalVisible={this.state.editModalVisible} /> : null}
        {this.state.copyModalVisible ? <CopyModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} id={this.state.id} copyModalVisible={this.state.copyModalVisible} /> : null}
        {this.state.importModalVisible ? <FormImport handleCancel={this.handleCancel} handleSearch={this.handleSearch} importModalVisible={this.state.importModalVisible} /> : null}
      </div>
    );
  }
}
export default withTranslation()(dataTarget);
